import { render } from "./deviceAdd.vue?vue&type=template&id=e0fba800&scoped=true"
import script from "./deviceAdd.vue?vue&type=script&lang=js"
export * from "./deviceAdd.vue?vue&type=script&lang=js"

import "./deviceAdd.vue?vue&type=style&index=0&id=e0fba800&scoped=true&lang=scss"

import exportComponent from "D:\\peizhe_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0fba800"]])

export default __exports__